function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M5.732 13.01l7.425-7.424s1.768-1.768-.354-3.89c-2.121-2.12-3.889-.353-3.889-.353L1.49 8.768s-1.408 1.42 0 2.828c1.485 1.485 2.828 0 2.828 0l6.718-6.717c.707-.707 1.06-1.061.353-1.768-.707-.707-1.06-.354-1.768.353L3.257 9.828",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
function SvgAttachment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    fill: "none"
  }, props), _ref);
}
export default SvgAttachment;